import {useEffect, useState} from 'react';

import {useUser} from '../../../../../website-ui/hooks/use-user';
import {readArticleComments} from '../../../../../website-ui/use-cases/comments/read-article-comments';

export const useArticlePreviewComments = articleId => {
  const [isShowModal, setIsShowModal] = useState(false);
  const [isLoading, setIsPageLoading] = useState(true);
  const [comments, setComments] = useState([]);

  const handleCloseModal = () => setIsShowModal(false);

  const user = useUser();

  const handleClickGoToConversation = () => {
    if (user.isAuthenticated) {
      return setIsShowModal(true);
    }
  };

  useEffect(() => {
    readArticleComments(articleId)
      .then(repositoryComments => setComments(repositoryComments))
      .catch(() => setComments([]))
      .finally(() => setIsPageLoading(false));
  }, []);

  return {
    isShowModal,
    isShowLoader: isLoading,
    comments,
    handleCloseModal,
    handleClickGoToConversation
  };
};
